import { schema } from 'normalizr';

// schemas

export const bumpGroupSchema = new schema.Entity('bumpGroup', {
}, {
  idAttribute: '_id',
});
export const bumpGroupListSchema = [bumpGroupSchema];
